import { useNavigate } from '@tanstack/react-router'
import dayjs from 'dayjs'
import { title } from 'radash'
import InlineProfile from '~components/general/inline-profile'
import { AVATAR_DEFAULT } from '~constants'
import useBreakPoint from '~hooks/use-break-point'
import Consultation from '~models/consultation'
import getRootPath from '~utils/app/get-root-path'
import ConsultationCard from './consultation-card'

type ConsultationCardWithProfileProps = Readonly<{
  consultation: Consultation.Level1
}>

const ConsultationCardWithProfile = ({ consultation }: ConsultationCardWithProfileProps) => {
  const { id, thumbnail_url, owner, created_at, details, main_concern } = consultation

  const breakPoint = useBreakPoint()
  const navigate = useNavigate()

  const onClick = () => {
    navigate({ to: `${getRootPath()}/consultation/${id}`, resetScroll: true })
  }

  return (
    <ConsultationCard
      className="p-5 transition-colors last:border-b-0 hover:bg-gray-100 dark:hover:bg-gray-900 active:bg-gray-100 motion-reduce:transition-none flex-gap-x-4"
      onClick={onClick}
    >
      <InlineProfile size={breakPoint.lg ? 'sm' : 'md'}>
        <InlineProfile.Avatar thumbnailUri={owner?.thumbnail_uri || AVATAR_DEFAULT.OWNER} />
        <InlineProfile.Header
          nickname={owner.nickname || 'Unknown'}
          createdAt={dayjs(created_at).format('MMM DD, YYYY')}
        />
      </InlineProfile>
      {main_concern && <ConsultationCard.Label>{title(main_concern)}</ConsultationCard.Label>}
      <div className="flex justify-between flex-gap-x-4">
        <div className="min-w-0">
          {consultation.generated_title && (
            <ConsultationCard.Title>{consultation.generated_title}</ConsultationCard.Title>
          )}
          <ConsultationCard.Content>{details}</ConsultationCard.Content>
        </div>
        {thumbnail_url && (
          <ConsultationCard.Media url={thumbnail_url} alt="consultation-thumbnail" />
        )}
      </div>
    </ConsultationCard>
  )
}

export default ConsultationCardWithProfile
